import WaButton from "@awesome.me/webawesome-pro/dist/react/button/index.js";
import WaCard from "@awesome.me/webawesome-pro/dist/react/card/index.js";
import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { trackEvent } from "../analytics/plausible";

export const RouteError: React.FC = () => {
  const err = useRouteError();

  let title = "Something went wrong";
  let message = "Please try again.";

  if (isRouteErrorResponse(err)) {
    title = `${err.status} ${err.statusText}`;
    trackEvent("router_error", {
      error: title,
    });
    message = "The requested page could not be found.";
  } else if (err instanceof Error) {
    message = err.message;
  }

  return (
    <div
      className="wa-cluster"
      style={{
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
      }}
    >
      <div
        className="wa-stack wa-gap-m"
        style={{
          maxWidth: 480,
          textAlign: "center",
          alignItems: "center",
        }}
      >
        <WaCard>
          <div slot="header" className="wa-heading-l">
            {title}
          </div>
          <div className="wa-caption-l">{message}</div>
        </WaCard>

        <WaButton variant="brand" onClick={() => (window.location.href = "/")}>
          Return to Dashboard
        </WaButton>
      </div>
    </div>
  );
};
